import { useEffect } from "react";

export default function Seo({ title, description, keywords }) {
  useEffect(() => {
    if (title) document.title = title;
    const set = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    set("description", description);
    set("keywords", Array.isArray(keywords) ? keywords.join(", ") : keywords);
  }, [title, description, keywords]);
  return null;
}
